<template>
	<div class="landing-component-spacer" :style="customStyles"></div>
</template>

<script>
export default {
	name: 'LandingComponentSpacer',

	props: {
		customStyles: {
			type: Object,
			default: () => ({}),
		},
	},
}
</script>

<style lang="scss" scoped>
.landing-component-spacer {
	min-height: calc(100vh - 350px);
	width: 100%;
}
</style>
